import React from 'react';

const notImplemented = () => {
    throw new Error('method not implemented');
}

export interface CostReportSearchContext {
    value: string;
    change: (value: string) => void;
}

export const initialState: CostReportSearchContext = {
    value: '',
    change: notImplemented,
}

export const CostReportSearchContext = React.createContext<CostReportSearchContext>(initialState);